import styled, { css } from 'styled-components';
import { Box } from '@bechtel/gds';
import { BlockCommentProps } from './types';
import { BlockStatusCode } from '@bechtel/types';

function getCommentBorder(props: BlockCommentProps) {
  if (props.blockStatus === BlockStatusCode.BLOCK_RESOLVED || !props.canEditBlock)
    return css`
      & > :last-child > :last-child {
        border-bottom: 0px;
        padding-bottom: ${({ theme }) => theme.spacings[400]};
      }
    `;
}

export const BlockCommentContainerStyled = styled(Box).attrs({
  flexDirection: { sm: 'column' },
  flexGrow: { sm: 1 },
})`
  & > *:last-child {
    padding-bottom: ${({ theme }) => theme.spacings[400]};
  }
  ${getCommentBorder};
`;

export const BlockCommentStyled = styled(Box).attrs({ py: { sm: '500' } })`
  border-bottom: 1px solid ${({ theme }) => theme.colors.grey[300]};
  word-break: break-word;
  line-height: normal;
`;
